// AdminDashboard.js
import React from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { ArrowUpOutlined, UserOutlined, ShoppingCartOutlined } from '@ant-design/icons';

const AdminDashboard = () => {
  return (
    <div>
      <Row gutter={16} style={{ marginBottom: '24px' }}>
        <Col span={8}>
          <Card>
            <Statistic
              title="Total Users"
              value={1128}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<UserOutlined />}
              suffix={<ArrowUpOutlined style={{ fontSize: '12px' }} />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Total Orders"
              value={93}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<ShoppingCartOutlined />}
            />
          </Card>
        </Col>
        <Col span={8}>
          <Card>
            <Statistic
              title="Active Sessions"
              value={24}
              precision={0}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
      </Row>

      <Card title="Recent Activity" style={{ marginBottom: '24px' }}>
        <p>Admin activity log will go here...</p>
      </Card>

      <Card title="Quick Actions">
        <p>Quick action buttons will go here...</p>
      </Card>
    </div>
  );
};

export default AdminDashboard;